import { MessageLockIcon } from './MessageLockIcon';

/**
 * author: Simran
 * id 953DF020-3B6E-44ED-B858-A220EC7BE82A
 * name message-lock
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-lock.svg
 * tags
 * - Lock 
 */
export const MessageSecureIcon = MessageLockIcon;
export default MessageSecureIcon